import React from 'react';
import { vacancyApi } from '@cp/entities/vacancy';
import { ContentSkeleton } from '@cp/ds/src/components/contentSkeleton';
import { Button } from '@cp/ds/src/components/button';
import { DeleteIcon } from '@cp/ds/src/icons';
import { useDispatch } from 'react-redux';
import { ThunkDispatch } from '@reduxjs/toolkit';
import { VacancyEditForm, VacancyEditFormProps } from 'src/entities/vacancy';
import { Header } from '../header';
import { contentContanerSx, mapViewModelToFormValues } from '../../lib';
import { ExistedProps } from './model';

export * from './model';

export const Existed: React.FC<ExistedProps> = ({ id, onClose }) => {
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();
  const { data, isLoading: isLoadingVacancy } = vacancyApi.endpoints.getVacancyForCurrentClientById.useQuery({ id });

  const isLoading = isLoadingVacancy;

  const handleSubmit = React.useCallback<VacancyEditFormProps['onSubmit']>(
    (values) => {
      return dispatch(vacancyApi.endpoints.updateVacancyForCurrentClientById.initiate({ params: { id }, body: values }));
    },
    [dispatch, id],
  );

  const handleDelete = React.useCallback(async () => {
    await dispatch(vacancyApi.endpoints.deleteVacancyForCurrentClientById.initiate({ params: { id } }));
    onClose();
  }, [dispatch, id, onClose]);

  const defaultValues = React.useMemo(() => data && mapViewModelToFormValues(data), [data]);

  if (isLoading) {
    return <ContentSkeleton blocks={2} />;
  }

  if (!defaultValues) {
    return null;
  }

  return (
    <>
      <Header
        careerId={defaultValues.careerId}
        endAdornment={
          <Button onClick={handleDelete} sx={{ ml: 'auto', mr: 0 }} variant="text">
            <DeleteIcon fontSize="1.5rem" />
          </Button>
        }
        onGoBack={onClose}
      />
      <VacancyEditForm
        contentContainerSx={contentContanerSx}
        defaultValues={defaultValues}
        onComplete={onClose}
        onSecondaryButtonClick={handleDelete}
        onSubmit={handleSubmit}
        secondaryButtonTitle="Удалить"
        submitButtonTitle="Сохранить"
      />
    </>
  );
};
